import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";
import { IoAdd } from "react-icons/io5";
import { motion } from "framer-motion";

const LeaveType = () => {
  const leaveData = [
    { id: 1, type: "Annual Leave", days: 12, status: "Active" },
    { id: 2, type: "Medical Leave", days: 12, status: "Active" },
    { id: 3, type: "Casual Leave", days: 12, status: "Active" },
    { id: 4, type: "Other Leave", days: 12, status: "Active" },
  ];

  return (
    <motion.div
      className="card container py-3"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
    >
      <motion.div
        className="d-flex justify-content-between align-items-center mb-4 border-bottom pb-2"
        initial={{ opacity: 0, x: -20 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.1 }}
      >
        <motion.h5
          className="fw-semibold mb-3 text-primary"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.1 }}
        >
          Leave Type
        </motion.h5>

        <motion.button
          whileTap={{ scale: 0.9 }}
          className="btn btn-dark btn-sm d-flex align-items-center gap-1"
        >
          <IoAdd size={16} />
          Add Leave Type
        </motion.button>
      </motion.div>
      <div className="container">

        {/* HEADER */}

        {/* CARD */}
        <motion.div
          className="card shadow-sm border-0 rounded-3"
          initial={{ opacity: 0, scale: 0.97 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.15 }}
        >
          <div className="card-body">

            <h6 className="fw-semibold mb-3">Leave Type List</h6>

            <div className="table-responsive">
              <table className="table align-middle mb-0">

                <thead className="table-light">
                  <tr className="small">
                    <th><input type="checkbox" /></th>
                    <th>Leave Type</th>
                    <th>Leave Days</th>
                    <th>Status</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {leaveData.map((item, index) => (
                    <motion.tr
                      key={item.id}
                      className="small"
                      initial={{ opacity: 0, y: 15 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ delay: index * 0.08 }}
                      whileHover={{ scale: 1.01 }}
                    >
                      <td><input type="checkbox" /></td>

                      <td>{item.type}</td>
                      <td>{item.days}</td>

                      <td>
                        <motion.span
                          className="badge bg-success-subtle text-success rounded-pill px-3"
                          initial={{ scale: 0.8 }}
                          animate={{ scale: 1 }}
                          transition={{ delay: 0.2 }}
                        >
                          {item.status}
                        </motion.span>
                      </td>

                      <td className="text-center">
                        <motion.button
                          whileTap={{ scale: 0.8 }}
                          className="btn btn-sm btn-light me-2"
                        >
                          <FaEdit size={13} />
                        </motion.button>

                        <motion.button
                          whileTap={{ scale: 0.8 }}
                          className="btn btn-sm btn-light"
                        >
                          <FaTrash size={13} className="text-danger" />
                        </motion.button>
                      </td>
                    </motion.tr>
                  ))}
                </tbody>

              </table>
            </div>

          </div>
        </motion.div>

      </div>
    </motion.div>
  );
};

export default LeaveType;